
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goodtrust-life/signup",
      function () {
        return require("private-next-pages/goodtrust-life/signup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goodtrust-life/signup"])
      });
    }
  